import { render, staticRenderFns } from "./ListadoEventosClubs.vue?vue&type=template&id=0b8c3a68"
import script from "./ListadoEventosClubs.vue?vue&type=script&setup=true&lang=js"
export * from "./ListadoEventosClubs.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports